/* Progressive enhancement of Shopify's native cart form; no sample state. */
(() => {
  function initialise(scope) {
    scope.querySelectorAll('[data-hydratrail-cart]').forEach(root => {
      if (root.dataset.cartInitialised) return;
      root.dataset.cartInitialised = 'true';
      const form = root.querySelector('form');
      if (!form) return;
      const checkout = root.querySelector('[data-cart-checkout]');
      const status = root.querySelector('[data-cart-status]');
      function pending() {
        checkout.disabled = true;
        status.textContent = 'Select Update cart to confirm your quantities.';
      }
      root.querySelectorAll('[data-cart-quantity]').forEach(input => input.addEventListener('input', pending));
      root.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const input = button.parentElement.querySelector('input');
          const value = Number(input.value);
          const next = Math.max(0, (Number.isSafeInteger(value) ? value : 0) + Number(button.dataset.quantityStep));
          if (!Number.isSafeInteger(next)) return;
          input.value = next;
          pending();
        });
      });
      form.addEventListener('submit', event => {
        // Enter within a quantity field always updates; it must not imply checkout.
        if (event.submitter?.name === 'checkout' && checkout.disabled) event.preventDefault();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
